import { notification } from "antd";
import { ApolloError } from "apollo-boost";
import { action, makeAutoObservable, runInAction } from "mobx";
import { Api } from "../../common/Api";
import { usersStore } from "./UsersStore";

export class UserUpdateChooseCommunityStore {
  loading = false;
  visible = false;
  saving = false;
  communities = [];
  model = {
    userId: "",
    communityId: undefined,
  };

  constructor() {
    makeAutoObservable(this, {});
  }

  @action show(userId, communityId = undefined) {
    this.loading = true;
    this.model.userId = userId;
    this.model.communityId = communityId;
    this.visible = true;

    Api.community
      .communities({ size: 10000 })
      .then((res) => {
        runInAction(() => {
          this.communities = res.data.communities.items;
        });
      })
      .finally(() => (this.loading = false));
  }

  @action
  save(communityId) {
    this.visible = false;
    this.saving = true;
    return Api.user
      .setUserChooseCommunity({ userId: this.model.userId, communityId })
      .then((res) => {
        runInAction(() => {
          this.visible = false;
          setTimeout(() => {
            usersStore.refresh();
          }, 3000);
        });
        notification.success({ message: `Community Updated` });
      })
      .catch((err: ApolloError) => {})
      .finally(() => (this.saving = false));
  }

  @action
  close() {
    this.visible = false;
  }
}

export const userUpdateChooseCommunityStore = new UserUpdateChooseCommunityStore();
